export default __webpack_public_path__ + "static/media/unearthlyapprentice.0cacafbd.png";